export default "__VITE_ASSET__BKE32nez__"